<template>
  <v-container
    class="fill-height"
    fluid
    grid-list-xl
  >
    <v-row justify="center">
      <v-col cols="12">
        <material-card
          color="green"
        >
          <v-btn
            :to="'/accounts/create'"
            color="green"
            dark
          >
            <v-icon left>
              mdi-account-plus-outline
            </v-icon> Nova Conta
          </v-btn>
          <data-grid
            :headers="headers"
            :items="accounts.items"
            :options.sync="options"
            :count-items="accounts.total"
            :loading="loading"
          >
            <template v-slot:item.is_admin="{ item }">
              <v-chip
                :color="item.is_admin ? 'orange' : 'green'"
                dark
              >
                {{ item.is_admin ? 'Administrador' :
                  'Normal'
                }}
              </v-chip>
            </template>
            <template v-slot:item.auth_method="{ item }">
              <v-chip
                :color="item.auth_method.id ==1 ? 'gray': 'brown' "
                dark
              >
                {{ item.auth_method.name }}
              </v-chip>
            </template>
            <template v-slot:item.action="{ item }">
              <v-btn
                :title="'Editar '+item.name "
                :to="'/accounts/'+item.id+'/edit'"
                text
                icon
                color="blue"
              >
                <v-icon>mdi-pencil</v-icon>
              </v-btn>

              <v-btn
                :title="'Remover '+item.name "
                text
                icon
                color="red"
                @click="remove(item)"
              >
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </template>
          </data-grid>
        </material-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
  import {
    mapState,
  } from 'vuex'
  import MaterialCard from "../../components/material/Card";

  export default {
      components: {MaterialCard},
      data () {
      return {
        options: {
          page: 1,
          itemsPerPage: 10,
          sortBy: ['name'],
          sortDesc: [false],

        },
        headers: [
          {
            text: 'ID',
            value: 'id',
          },
          { text: 'Nome', value: 'name' },
          { text: 'E-mail', value: 'email' },
          { text: 'Administrador?', value: 'is_admin' },
          { text: 'Autenticação', value: 'auth_method', sortable: false },
          { text: 'Ações', value: 'action', sortable: false },
        ],
      }
    },

    computed: {
      ...mapState('account', ['accounts', 'current_unity']),
      ...mapState('app', ['loading']),

    },
    watch: {
      current_unity: {
        handler () {
          this.fetch()
        },
        deep: true,
      },
      options: {
        handler () {
          this.fetch()
        },
        deep: true,
      },
    },
    methods: {
      fetch () {
        this.options.unity_id = this.current_unity.id
        this.$store.dispatch('account/LIST', this.options)
      },
      remove (account) {
        if (confirm('Deseja mesmo remover esse item? Esta operação não pode ser desfeita.')) this.$store.dispatch('account/DELETE', account)
      },
    },
  }
</script>
